module.exports = __webpack_public_path__ + "static/media/Informationbanner.ad876f4d.png";